export default {
    android: {
        regular: {
            fontFamily: 'sans-serif',
            fontWeight: 'normal',
        },
        light: {
            fontFamily: 'sans-serif-light',
            fontWeight: 'normal',
        },
        condensed: {
            fontFamily: 'sans-serif-condensed',
            fontWeight: 'normal',
        },
        condensed_light: {
            fontFamily: 'sans-serif-condensed',
            fontWeight: 'light',
        },
        black: {
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
        },
        thin: {
            fontFamily: 'sans-serif-thin',
            fontWeight: 'normal',
        },
        medium: {
            fontFamily: 'sans-serif-medium',
            fontWeight: 'normal',
        },
        bold: {
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
        },
    },
    default: {},
};
